import { AfterViewInit, Component } from '@angular/core';

@Component({
  selector: 'splash-screen',
  templateUrl: './splash-screen.component.html',
  styleUrls: ['./splash-screen.component.scss'],
  standalone: false,
})
export class SplashScreenComponent implements AfterViewInit {
  public showContent: boolean = false;
  public showLoadingSpinner: boolean = false;

  ngAfterViewInit(): void {
    switch (window.location.pathname) {
      case '/auth/login':
      case '/auth/forgot-password':
      case '/auth/reset-password':
      case '/confirm-registration':
      case '/error':
      case '/maintenance':
      case '/payment/failed':
      case '/payment/successful':
      case '/sso/authorize':
      case '/oauth/consent':
        setTimeout(() => (this.showContent = true), 200);
        break;

      default:
        setTimeout(() => (this.showContent = true));
        break;
    }

    setTimeout(() => (this.showLoadingSpinner = true), 400);
  }
}
